import { render, staticRenderFns } from "./AparelhoSimilar.vue?vue&type=template&id=287934c1&scoped=true&"
import script from "./AparelhoSimilar.vue?vue&type=script&lang=js&"
export * from "./AparelhoSimilar.vue?vue&type=script&lang=js&"
import style0 from "./AparelhoSimilar.vue?vue&type=style&index=0&id=287934c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287934c1",
  null
  
)

export default component.exports